import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

interface GoldcastWidget {
	RegistrationWidget: new (config: {
		seriesId?: string;
		isSeries?: boolean;
		registrationFormUrl?: string;
		mode: 'embed' | 'popup';
		containerSelector: string;
		theme_obj: Record<string, string>;
		backendUrl: string;
		autoResizeIframeHeight: boolean;
		iframeWidth: string;
		event_id?: string;
	}) => void;
}

declare global {
	interface Window {
		GOLDCAST: GoldcastWidget;
	}
}

interface GoldcastFormProps {
	eventId?: string;
	eventType: string;
	registrationUrl?: string;
	seriesId?: string;
}

export const GoldcastForm = ({
	eventId,
	eventType,
	registrationUrl,
	seriesId,
}: GoldcastFormProps) => {
	useEffect(() => {
		if (eventType === 'series') {
			new window.GOLDCAST.RegistrationWidget({
				seriesId: seriesId,
				isSeries: true,
				// registrationFormUrl must be obtained from Goldcast support
				registrationFormUrl: registrationUrl,
				// Accepts 'embed' or 'popup'
				mode: 'embed',
				// Only needed in embed mode
				containerSelector: '#goldcast-registration-form',
				theme_obj: {
					'--vertical-spacing': '0px',
					'--theme-secondary-color': '#02291c',
					'--label-fontsize': '16px',
					'--splash-background-color': 'transparent',
					'--splash-background-shade': '255, 255, 255, 1',
					'--splash-text-color': '#02291c',
					'--form-padding': '0',
					'--button-radius': '4px',
					'--error-color': '#994731',
					'--input-border': '1px solid #d4d1cb',
				},
				backendUrl: 'https://backend.goldcast.io',
				autoResizeIframeHeight: true,
				iframeWidth: '100%',
			});
		}

		if (eventType === 'oneOffEvent') {
			new window.GOLDCAST.RegistrationWidget({
				event_id: eventId,
				// Accepts 'embed' or 'popup'
				mode: 'embed',
				// Only needed in embed mode
				containerSelector: '#goldcast-registration-form',
				theme_obj: {
					'--vertical-spacing': '0px',
					'--theme-secondary-color': '#02291c',
					'--label-fontsize': '16px',
					'--splash-background-color': 'transparent',
					'--splash-background-shade': '255, 255, 255, 1',
					'--splash-text-color': '#02291c',
					'--form-padding': '0',
					'--button-radius': '4px',
					'--error-color': '#994731',
					'--input-border': '1px solid #d4d1cb'
				},
				backendUrl: 'https://backend.goldcast.io',
				autoResizeIframeHeight: true,
				iframeWidth: '100%',
			});
		}
	}, [eventType]);

	return (
		<div>
			<Helmet>
				<script src='https://dnf20ypvrc856.cloudfront.net/embed.js' />
			</Helmet>
			<div id='goldcast-registration-form' />
		</div>
	);
};
